<template>
  <div class="c-case c-standard fullWidth">
    <h3 class='title_h3 relative'>
      <span>{{ text.title }}</span>
      <div class="textBgCenter absolute" style='top: -50%'></div>
    </h3>
    <div class="c-case__block">
      <q-carousel class="bg-color-transparent c-case__block--height" v-model="slide" prev-icon="img:./icon_prev.png" next-icon="img:./icon_next.png" transition-prev="slide-right" transition-next="slide-left" swipeable animated control-color="grey-10" navigation padding arrows  navigation-icon='fa fa-circle-o' navigation-active-icon='fa fa-circle'>
        <q-carousel-slide v-for="(item,index) in caseArr" :name="index" class="column no-wrap" :key="index">
          <div class="row fit q-gutter-xs q-col-gutter" style='justify-content: space-between;align-items: flex-start'>
            <div class="c-case__item" v-for="(x, y) in item.content" :key="y">
              <div class="c-case__item--img"  :style="{backgroundImage:'url('+ x.img +')'}">
              </div>
              <h4>{{ x.title }}</h4>
            </div>
          </div>
        </q-carousel-slide>
      </q-carousel>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'caseBlock',
    // props: ['contact'],
    components: {
      'q-carousel': Quasar.QCarousel,
      'q-carousel-slide': Quasar.QCarouselSlide
    },
    data(){
      return{
        text:{
          title: this.$t('case_block.title')
        },
        slide: 0,
        caseArr: [
          {page: 1, content:[
            {img: require('../../assets/img/icon_video.png'), title: this.$t('case_block.case.case_1.title')},
            {img: require('../../assets/img/icon_video.png'), title: this.$t('case_block.case.case_2.title')},
            {img: require('../../assets/img/icon_video.png'), title: this.$t('case_block.case.case_3.title')},
            {img: require('../../assets/img/icon_video.png'), title: this.$t('case_block.case.case_4.title')}
          ]},
          {page: 2, content:[
            {img: require('../../assets/img/icon_video.png'), title: this.$t('case_block.case.case_5.title')}
          ]},
        ],
      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
